<script>
	// NPM Modules
	import { navigate } from 'svelte-navaid';
	// Stores
	import AuthUserStore from '@/Stores/AuthUserStore.js';
	// Components
	import Helmet from '@/Components/Helmet.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	import TextInput from '@/Components/TextInput.svelte';
	import Logo from '@/Components/Logo.svelte';
	// Constants
	import config from '@/config.js';

	let errors = null;
	let success = null;

	const params = new Proxy(new URLSearchParams(window.location.search), {
		get: (searchParams, prop) => searchParams.get(prop)
	});

	let sending = false;
	let values = {
		email: '',
		password: '',
		password_confirmation: '',
		token: params.token
	};

	function handleSubmit() {
		sending = true;
		AuthUserStore.reset(values)
			.then((response) => {
				errors = null;
				success = response.meta.message;
				setTimeout(() => {
					navigate('/login');
				}, 1000);
			})
			.catch((error) => {
				errors = error;
			})
			.finally(() => (sending = false));
	}
</script>

<Helmet title="Login" />
<div class="flex items-center justify-center min-h-screen p-6 bg-brand-black">
	<div class="w-full max-w-md">
		{#if config.BRAND == 'socialbet'}
			<img
				src="/images/logo.png"
				class="block max-w-xs mx-auto h-10"
				alt={config.BRAND_NAME}
				height="32px"
				width="126px"
			/>
		{:else}
			<div class="w-auto h-20 mx-auto block px-16">
				<Logo />
			</div>
		{/if}

		<form on:submit|preventDefault={handleSubmit} class="mt-8 overflow-hidden bg-white rounded-lg shadow-xl">
			<div class="px-10 py-12">
				<h1 class="text-3xl font-bold text-center">Reset your password!</h1>
				<div class="w-24 mx-auto mt-6 border-b-2" />

				<div class="flex w-full my-4 justify-center text-center">
					<p>Put in your email and new password and we will update your accounts password!</p>
				</div>

				<TextInput
					className="mt-6"
					label="Email"
					name="email"
					type="email"
					errors={errors && errors.email}
					bind:value={values.email}
				/>

				<TextInput
					className="mt-6"
					label="New password"
					name="password"
					type="password"
					errors={errors && errors.password}
					bind:value={values.password}
				/>

				<TextInput
					className="mt-6"
					label="Confirm new password"
					name="password_confirmation"
					type="password"
					errors={errors && errors.password_confirmation}
					bind:value={values.password_confirmation}
				/>
				{#if errors && errors.length > 0}
					{#each errors as error}
						<div class="-mb-2 pt-3 text-center form-error">{error}</div>
					{/each}
				{/if}
				{#if success}
					<div class="-mb-2 pt-3 text-center form-success">{success}</div>
				{/if}
			</div>

			<div class="flex items-center justify-end px-10 py-4 bg-gray-100 border-t border-gray-200">
				<LoadingButton
					type="submit"
					loading={sending}
					className="px-6 py-3 rounded bg-secondary text-white text-sm font-bold
          whitespace-nowrap hover:bg-dark"
				>
					Reset my password
				</LoadingButton>
			</div>
		</form>
	</div>
</div>
